import { render, staticRenderFns } from "./GameHistoryItem.vue?vue&type=template&id=6e11de7d&"
import script from "./GameHistoryItem.vue?vue&type=script&lang=js&"
export * from "./GameHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./GameHistoryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports